import React, { useEffect, useState } from 'react'
import { HideIcon, IconButton, MaskedTextInput, Tooltip, ViewIcon } from '@paypalcorp/pp-react'
import { trackClick, trackFormValidationClick } from 'ppbl/utils/fpti-helper'

const MaskedTextInputAdapter = ({
  input,
  meta,
  toolTip,
  fptiPage,
  showRightIcon=false,
  maskOptions,
  ...rest
}) => {

  const [isVisible, setVisible] = useState(false)
  const ToolTipIcon = (
    <Tooltip name="masked-input-tooltip" description={toolTip} />
  )

  const handleChange = (value, unmaskedValue, typedValue) => {
    input.onChange(value)
  }

  const handleFocus = (e) => {
    if (input && typeof input.onFocus === 'function') {
      input.onFocus(e)
    }
    trackClick({
      page: fptiPage,
      component: input.name,
      link: input.name,
    })
  }

  const handleBlur = (e) => {
    input.onBlur(e)
  }

  useEffect(() => {
    if (meta.touched && meta.error) {
      trackFormValidationClick({
        page: fptiPage,
        message: meta.error,
        component: input.name,
        link: input.name,
      })
    }
  }, [meta.error, meta.touched])

  const toggleDigitVisibility = () => setVisible(!isVisible)
  
  const controlledMaskOptions = showRightIcon && maskOptions.get(isVisible)
  
  const RightIcon = (
    <IconButton
      svgIconComponent={isVisible ? HideIcon : ViewIcon}
      onClick={toggleDigitVisibility}
    />
  )

  return (
    <MaskedTextInput
      {...rest}
      onAccept={handleChange}
      rightIcon={showRightIcon && RightIcon}
      {...(toolTip
        ? {
            rightIcon: ToolTipIcon,
          }
        : {})}
      maskOptions={showRightIcon ? controlledMaskOptions : maskOptions}
      value={input.value ? input.value : ''}
      errorText={meta.touched ? meta.error : ''}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  )
}

export default MaskedTextInputAdapter
